var map = {
	"./2025/1000Icon.png": 333,
	"./2025/1400Icon.png": 334,
	"./2025/1600Icon.png": 335,
	"./2025/900Icon.png": 336,
	"./2025/arrow.gif": 22,
	"./2025/arrow_next.png": 337,
	"./2025/arrow_next2.png": 183,
	"./2025/black-arrow-gif.gif": 1166,
	"./2025/black-arrow.png": 1167,
	"./2025/blue-arrow.gif": 1168,
	"./2025/multiplayerIcon.png": 338,
	"./2025/nextTopic_bg.png": 1169,
	"./2025/topic1000/a_video.png": 1170,
	"./2025/topic1000/a_video_mobile.png": 1171,
	"./2025/topic1000/background-1.png": 1172,
	"./2025/topic1000/background-2.png": 1173,
	"./2025/topic1000/background-3.png": 1174,
	"./2025/topic1000/background-4-mobile.png": 1175,
	"./2025/topic1000/background-4.png": 1176,
	"./2025/topic1000/background-5-1.png": 1177,
	"./2025/topic1000/background-6.png": 339,
	"./2025/topic1000/computer-mobile.png": 340,
	"./2025/topic1000/computer.png": 341,
	"./2025/topic1000/ele_example_1_1.png": 342,
	"./2025/topic1000/ele_example_2_1.png": 343,
	"./2025/topic1000/ele_example_2_2.png": 344,
	"./2025/topic1000/ele_example_3_1.png": 345,
	"./2025/topic1000/ele_example_3_2.png": 346,
	"./2025/topic1000/ele_example_4_1.png": 347,
	"./2025/topic1000/ele_example_4_2.png": 348,
	"./2025/topic1000/ele_example_4_3.png": 349,
	"./2025/topic1000/example_img_1_1.png": 350,
	"./2025/topic1000/example_img_1_2.png": 351,
	"./2025/topic1000/example_img_1_3.png": 352,
	"./2025/topic1000/example_img_1_4.png": 353,
	"./2025/topic1000/example_img_1_5.png": 354,
	"./2025/topic1000/example_img_1_6.png": 355,
	"./2025/topic1000/example_img_1_6_1.png": 356,
	"./2025/topic1000/example_img_1_7.png": 1178,
	"./2025/topic1000/example_img_1_7_1.png": 357,
	"./2025/topic1000/person-back.png": 1179,
	"./2025/topic1000/person-cover.png": 1180,
	"./2025/topic1000/person.png": 1181,
	"./2025/topic1000/quiz_bg.png": 1182,
	"./2025/topic1000/quiz_bg_mobile.png": 1183,
	"./2025/topic1000/section2_4_1.png": 1184,
	"./2025/topic1000/section2_4_3.png": 1185,
	"./2025/topic1000/section2_4_3_m.png": 1186,
	"./2025/topic1000/section2_back.png": 1187,
	"./2025/topic1000/section3_1_0.png": 358,
	"./2025/topic1000/section3_1_1.png": 1188,
	"./2025/topic1000/section3_1_2.png": 359,
	"./2025/topic1000/section3_2_1.png": 360,
	"./2025/topic1000/section3_2_1_cn.png": 361,
	"./2025/topic1000/section3_2_1_sc.png": 362,
	"./2025/topic1000/section3_3_1.png": 363,
	"./2025/topic1000/section3_3_2.png": 364,
	"./2025/topic1000/section3_3_2_m.png": 365,
	"./2025/topic1000/section3_4_1.png": 1189,
	"./2025/topic1000/section3_back.png": 1190,
	"./2025/topic1000/section4/arrow-circle.png": 1191,
	"./2025/topic1000/section4/arrow.png": 1192,
	"./2025/topic1000/section4/background-1.png": 1193,
	"./2025/topic1000/section4/background-2.png": 1194,
	"./2025/topic1000/section4/background-3-mobile.png": 1195,
	"./2025/topic1000/section4/background-3.png": 1196,
	"./2025/topic1000/section4/background-4.png": 1197,
	"./2025/topic1000/section4/background-5.png": 1198,
	"./2025/topic1000/section4/background-6.png": 1199,
	"./2025/topic1000/section4/black-arrow.png": 1200,
	"./2025/topic1000/section4/computer-icon.png": 1201,
	"./2025/topic1000/section4/dialog-box-1-en.png": 1202,
	"./2025/topic1000/section4/dialog-box-1-mobile.png": 1203,
	"./2025/topic1000/section4/dialog-box-1.png": 1204,
	"./2025/topic1000/section4/dialog-box-2-en.png": 1205,
	"./2025/topic1000/section4/dialog-box-2-mobile.png": 1206,
	"./2025/topic1000/section4/dialog-box-2.png": 1207,
	"./2025/topic1000/section4/dialog-box-3-mobile.png": 1208,
	"./2025/topic1000/section4/dialog-box-3.png": 1209,
	"./2025/topic1000/section4/dialog-box-4-mobile.png": 1210,
	"./2025/topic1000/section4/dialog-box-4.png": 1211,
	"./2025/topic1000/section5/background-1.png": 1212,
	"./2025/topic1000/section5/background-2.png": 1213,
	"./2025/topic1000/section5/background-3.png": 1214,
	"./2025/topic1000/section5/blue-box.png": 1215,
	"./2025/topic1000/section5/bottom-decoration.png": 1216,
	"./2025/topic1000/section5/flower-computer.png": 1217,
	"./2025/topic1000/section5/orange-box.png": 1218,
	"./2025/topic1000/section5/persons.png": 1219,
	"./2025/topic1000/spot1.png": 1220,
	"./2025/topic1000/spot2.png": 1221,
	"./2025/topic1000/spot3.png": 1222,
	"./2025/topic1000/warning.png": 1223,
	"./2025/topic1400/elePerson_2_1.png": 366,
	"./2025/topic1400/elePerson_2_2.png": 367,
	"./2025/topic1400/file_bg.png": 1224,
	"./2025/topic1400/file_bg_m.png": 1225,
	"./2025/topic1400/file_bg_m2.png": 1226,
	"./2025/topic1400/file_left_person.png": 368,
	"./2025/topic1400/file_right_img.png": 369,
	"./2025/topic1400/left_icon.svg": 1227,
	"./2025/topic1400/line_left_bg.png": 1228,
	"./2025/topic1400/line_right_bg.png": 1229,
	"./2025/topic1400/news_bg.png": 1230,
	"./2025/topic1400/practice_img.png": 370,
	"./2025/topic1400/practice_left_bg.png": 371,
	"./2025/topic1400/quiz_bg.png": 1231,
	"./2025/topic1400/quiz_bg_mobile.png": 1232,
	"./2025/topic1400/right_icon.png": 372,
	"./2025/topic1400/risk_person.png": 373,
	"./2025/topic1400/section3_3_1.png": 374,
	"./2025/topic1400/section3_3_2.png": 375,
	"./2025/topic1400/section3_3_2_m.png": 376,
	"./2025/topic1400/shared_file_bg.png": 1233,
	"./2025/topic1400/shared_file_bg1.png": 1234,
	"./2025/topic1400/shared_file_bg2.png": 1235,
	"./2025/topic1400/shared_left_bottom.png": 184,
	"./2025/topic1400/top_bg.png": 1236,
	"./2025/topic1400/top_ele1.png": 1237,
	"./2025/topic1400/top_flowers.png": 377,
	"./2025/topic1400/top_icon.png": 1238,
	"./2025/topic1400/top_person.png": 378,
	"./2025/topic1400/top_tips.png": 1239,
	"./2025/topic1400/wrong_icon.png": 379,
	"./2025/topic1600/background-1.png": 1240,
	"./2025/topic1600/background-2.png": 1241,
	"./2025/topic1600/background-3.png": 1242,
	"./2025/topic1600/background-4.png": 1243,
	"./2025/topic1600/background-5-1.png": 1244,
	"./2025/topic1600/background-5.png": 1245,
	"./2025/topic1600/background-6-mobile.png": 1246,
	"./2025/topic1600/background-6.png": 1247,
	"./2025/topic1600/computer.png": 1248,
	"./2025/topic1600/connect-vpn-1.png": 1249,
	"./2025/topic1600/connect-vpn-2.png": 1250,
	"./2025/topic1600/example-1.png": 380,
	"./2025/topic1600/flower-1.png": 1251,
	"./2025/topic1600/flower.png": 1252,
	"./2025/topic1600/header-icon.png": 1253,
	"./2025/topic1600/info-lock.png": 1254,
	"./2025/topic1600/person-1.png": 1255,
	"./2025/topic1600/person-2.png": 1256,
	"./2025/topic1600/person.png": 1257,
	"./2025/topic1600/quiz_bg.png": 1258,
	"./2025/topic1600/quiz_bg_mobile.png": 1259,
	"./2025/topic1600/right-icon.png": 1260,
	"./2025/topic1600/section2_7.png": 381,
	"./2025/topic1600/section2_7_1.png": 382,
	"./2025/topic1600/section2_7_mobile.png": 383,
	"./2025/topic1600/section2_8.png": 384,
	"./2025/topic1600/section2_81.png": 385,
	"./2025/topic1600/section2_9.png": 386,
	"./2025/topic1600/silkRibbon-1.png": 1261,
	"./2025/topic1600/silkRibbon-2.png": 1262,
	"./2025/topic1600/transfer-arrow.png": 1263,
	"./2025/topic1600/vpn-background-1-mobile.png": 1264,
	"./2025/topic1600/vpn-background-1.png": 1265,
	"./2025/topic1600/vpn-background-2-mobile.png": 1266,
	"./2025/topic1600/vpn-background-2.png": 1267,
	"./2025/topic1600/wave.png": 1268,
	"./2025/topic1600/wrong-icon.png": 1269,
	"./2025/topic900/CenterCircle.png": 387,
	"./2025/topic900/arrow_orange_left.png": 1270,
	"./2025/topic900/arrow_r.png": 1271,
	"./2025/topic900/back_1_3.png": 1272,
	"./2025/topic900/back_1_3_m.png": 388,
	"./2025/topic900/back_lines1.png": 1273,
	"./2025/topic900/back_pad1.png": 1274,
	"./2025/topic900/back_piece1.5.png": 1275,
	"./2025/topic900/bottom_left.png": 1276,
	"./2025/topic900/code_icon1.png": 389,
	"./2025/topic900/code_icon2.png": 390,
	"./2025/topic900/code_icon3.png": 391,
	"./2025/topic900/code_icon4.png": 392,
	"./2025/topic900/code_icon5.png": 393,
	"./2025/topic900/code_icon6.png": 394,
	"./2025/topic900/correct_icon.png": 185,
	"./2025/topic900/eleImg_pwd_2_1.png": 1277,
	"./2025/topic900/eleImg_pwd_2_2.png": 1278,
	"./2025/topic900/eleImg_pwd_2_3.png": 1279,
	"./2025/topic900/eleImg_pwd_2_4.png": 1280,
	"./2025/topic900/elePerson1-1.png": 395,
	"./2025/topic900/elePerson_2_1.png": 186,
	"./2025/topic900/elePerson_2_2.png": 187,
	"./2025/topic900/elePerson_2_3.png": 396,
	"./2025/topic900/elePerson_2_4.png": 397,
	"./2025/topic900/ele_Preson_3_2.png": 1281,
	"./2025/topic900/ele_Preson_3_2_m.png": 1282,
	"./2025/topic900/ele_icon_lock.png": 1283,
	"./2025/topic900/en_img.png": 398,
	"./2025/topic900/error_icon.png": 188,
	"./2025/topic900/flower.png": 1284,
	"./2025/topic900/icon1-1.png": 1285,
	"./2025/topic900/icon_clock1.png": 1286,
	"./2025/topic900/icon_correct.png": 1287,
	"./2025/topic900/icon_error.png": 1288,
	"./2025/topic900/icon_flower1.png": 1289,
	"./2025/topic900/icon_text1.png": 1290,
	"./2025/topic900/icon_text2.png": 1291,
	"./2025/topic900/line_bg_2.png": 1292,
	"./2025/topic900/pwd_type1.png": 163,
	"./2025/topic900/pwd_type2.png": 164,
	"./2025/topic900/pwd_type_3_1.png": 233,
	"./2025/topic900/pwd_type_3_3.png": 234,
	"./2025/topic900/pwd_type_3_4.png": 200,
	"./2025/topic900/pwd_type_3_4_1.png": 399,
	"./2025/topic900/quiz_bg.png": 1293,
	"./2025/topic900/quiz_bg_mobile.png": 1294,
	"./2025/topic900/step/step1.png": 541,
	"./2025/topic900/step/step2.png": 542,
	"./2025/topic900/step/step3.png": 543,
	"./2025/topic900/step/step4.png": 544,
	"./2025/topic900/tab/item_bg1.png": 1295,
	"./2025/topic900/tab/item_bg2.png": 1296,
	"./2025/topic900/tab/item_bg3.png": 1297,
	"./2025/topic900/tab/person_tab.png": 400,
	"./2025/topic900/tab/tab1_1.png": 545,
	"./2025/topic900/tab/tab1_2.png": 546,
	"./2025/topic900/tab/tab2_1.png": 547,
	"./2025/topic900/tab/tab2_2.png": 548,
	"./2025/topic900/tab/tab2_3.png": 549,
	"./2025/topic900/tab/tab3_1.png": 550,
	"./2025/topic900/tab/tab3_2.png": 551,
	"./2025/topic900/verify/verify_bg1.png": 552,
	"./2025/topic900/verify/verify_bg2.png": 553,
	"./2025/topic900/verify/verify_bg3.png": 554,
	"./2025/topic900/verify/verify_bg4.png": 555,
	"./2025/topic900/verify/verify_icon1.png": 556,
	"./2025/topic900/verify/verify_icon2.png": 557,
	"./2025/topic900/verify/verify_icon3.png": 558,
	"./2025/topic900/verify/verify_icon4.png": 559,
	"./2025/topic900/video_3people.png": 1298,
	"./2025/topic900/video_3people_m.png": 1299,
	"./2025/topicQuiz/answer_left.png": 401,
	"./2025/topicQuiz/firework.png": 1300,
	"./2025/topicQuiz/left_test.png": 402,
	"./2025/topicQuiz/not_pass.png": 403,
	"./2025/topicQuiz/pass.png": 404,
	"./2025/topicQuiz/quiz_bg.png": 1301,
	"./2025/topicQuiz/quiz_bg_1.png": 1302,
	"./2025/wPeople1.png": 1303,
	"./2025/wPeople2.png": 1304,
	"./2025/welcomeBg.png": 1305,
	"./2025/welcomeBg_m.png": 1306,
	"./2025/welcomeInfo.png": 1307,
	"./2025/welcomeStarrt.png": 1308,
	"./2025/welcome_bg_left.png": 1309,
	"./3d-speech-bubble.png": 1310,
	"./817w2.png": 405,
	"./817w3.png": 406,
	"./9881.png": 1311,
	"./9882.png": 1312,
	"./Artboard 20 1.svg": 1313,
	"./Artboard 20 2.svg": 1314,
	"./Boss-right.png": 1315,
	"./CSRealCase1-en-moblie.jpg": 560,
	"./CSRealCase1-en.jpg": 561,
	"./CSRealCase1-moblie.jpg": 562,
	"./CSRealCase1.jpg": 563,
	"./CSRealCase1.png": 1316,
	"./CSRealCase2-en-moblie.jpg": 564,
	"./CSRealCase2-en.jpg": 565,
	"./CSRealCase2-moblie.jpg": 566,
	"./CSRealCase2.jpg": 567,
	"./CSRealCase3-en-moblie.jpg": 568,
	"./CSRealCase3-en.jpg": 569,
	"./CSRealCase3-moblie.jpg": 570,
	"./CSRealCase3.jpg": 571,
	"./CommonInternetWhalingAttacks1.jpg": 572,
	"./CommonInternetWhalingAttacks1.png": 1317,
	"./CommonInternetWhalingAttacks2.jpg": 573,
	"./CommonInternetWhalingAttacks2.png": 1318,
	"./CommonInternetWhalingAttacks3.jpg": 574,
	"./CommonInternetWhalingAttacks3.png": 1319,
	"./CommonInternetWhalingAttacks4.jpg": 575,
	"./CommonInternetWhalingAttacks4.png": 1320,
	"./CustomerRealCase1-en-moblie.jpg": 576,
	"./CustomerRealCase1-en.jpg": 577,
	"./CustomerRealCase1-moblie.jpg": 578,
	"./CustomerRealCase1.jpg": 579,
	"./E-commerce-gif1.gif": 1321,
	"./E-commerce-gif2.gif": 1322,
	"./E-commerce-gif3.gif": 1323,
	"./E-commerce-gif4.gif": 1324,
	"./E-commerceRealCase1-en.jpg": 580,
	"./E-commerceRealCase1-moblie-en.jpg": 581,
	"./E-commerceRealCase1-moblie.jpg": 582,
	"./E-commerceRealCase1.jpg": 583,
	"./E-commerceRealCase2-en.jpg": 584,
	"./E-commerceRealCase2-mobile.jpg": 585,
	"./E-commerceRealCase2-moblie-en.jpg": 586,
	"./E-commerceRealCase2-moblie.jpg": 587,
	"./E-commerceRealCase2.jpg": 588,
	"./Finance.png": 407,
	"./FinanceRealCase-en.jpg": 589,
	"./FinanceRealCase-mobile-en.jpg": 590,
	"./FinanceRealCase-mobile-sc.jpg": 591,
	"./FinanceRealCase-mobile.jpg": 592,
	"./FinanceRealCase-sc.jpg": 593,
	"./FinanceRealCase.jpg": 594,
	"./FinanceRealCase.png": 1325,
	"./FinanceRealCase2-en.jpg": 595,
	"./FinanceRealCase2-mobile-en.jpg": 596,
	"./FinanceRealCase2-mobile-sc.jpg": 597,
	"./FinanceRealCase2-mobile.jpg": 598,
	"./FinanceRealCase2-sc.jpg": 599,
	"./FinanceRealCase2.jpg": 600,
	"./G5584.png": 1326,
	"./Group5600.png": 1327,
	"./HRRealCase-en.jpg": 601,
	"./HRRealCase-mobile-en.jpg": 602,
	"./HRRealCase-mobile.jpg": 603,
	"./HRRealCase.jpg": 604,
	"./IT.png": 408,
	"./ITRealCase.svg": 1328,
	"./ITRealCase1-en.jpg": 605,
	"./ITRealCase1-moblie-en.jpg": 606,
	"./ITRealCase1-moblie.jpg": 607,
	"./ITRealCase1.jpg": 608,
	"./ITRealCase2-en.jpg": 609,
	"./ITRealCase2-moblie-en.jpg": 610,
	"./ITRealCase2-moblie.jpg": 611,
	"./ITRealCase2.jpg": 612,
	"./ITRealCase3-en.jpg": 613,
	"./ITRealCase3-moblie-en.jpg": 614,
	"./ITRealCase3-moblie.jpg": 615,
	"./ITRealCase3.jpg": 616,
	"./IndexPrompt.jpg": 617,
	"./IndexPrompt.png": 1329,
	"./Introduction.png": 1330,
	"./Lady.svg": 1331,
	"./Link.png": 189,
	"./Ma009-1.svg": 1332,
	"./Ma009-2.svg": 1333,
	"./Ma009-3.svg": 1334,
	"./Ma009-4.svg": 1335,
	"./Ma009-5.svg": 1336,
	"./Ma009-6.svg": 1337,
	"./Manufacturing.png": 1338,
	"./MarketRealCase.jpg": 618,
	"./MarketRealCase1-en-moblie.jpg": 619,
	"./MarketRealCase1-en.jpg": 620,
	"./MarketRealCase1-moblie.jpg": 621,
	"./MarketRealCase1.jpg": 622,
	"./MarketRealCase1.png": 1339,
	"./MarketRealCase1.svg": 1340,
	"./MarketRealCase2-en-moblie.jpg": 623,
	"./MarketRealCase2-en.jpg": 624,
	"./MarketRealCase2-moblie.jpg": 625,
	"./MarketRealCase2.jpg": 626,
	"./MarketRealCase3-en.jpg": 627,
	"./Mc001-Picture1.png": 1341,
	"./Mc001-Picture2.png": 1342,
	"./Mc001-Picture3.png": 1343,
	"./NGORealCase1-en.jpg": 628,
	"./NGORealCase1-moblie-en.jpg": 629,
	"./NGORealCase1-moblie.jpg": 630,
	"./NGORealCase1.jpg": 631,
	"./NGORealCase2-en.jpg": 632,
	"./NGORealCase2-moblie-en.jpg": 633,
	"./NGORealCase2-moblie.jpg": 634,
	"./NGORealCase2.jpg": 635,
	"./PPII.png": 1344,
	"./Pictureds1.png": 1345,
	"./Pictureds10.png": 1346,
	"./Pictureds2.png": 1347,
	"./Pictureds3.png": 1348,
	"./Pictureds4.png": 1349,
	"./Pictureds5.png": 1350,
	"./Pictureds6.png": 1351,
	"./Pictureds7.png": 1352,
	"./Pictureds8.png": 1353,
	"./Pictureds9.png": 1354,
	"./PwC_Repre_Illus_Iso_02_IoT_RGB.png": 1355,
	"./PwC_Repre_Illus_Iso_05_Chatbot_RGB.png": 1356,
	"./RealCase-en.png": 1357,
	"./RealCase-mobile-en.jpg": 636,
	"./RealCase-mobile-sc.jpg": 637,
	"./RealCase-sc.jpg": 638,
	"./RealCase.mobile.jpg": 639,
	"./RealCase.png": 1358,
	"./Realcase-socialMedia-en.png": 1359,
	"./Realcase-socialMedia-mobile-en.png": 1360,
	"./Realcase-socialMedia-mobile.jpg": 640,
	"./Realcase-socialMedia.jpg": 641,
	"./Shield.png": 409,
	"./Software-Downloading-icon1.png": 1361,
	"./Software-Downloading-icon2.png": 1362,
	"./Software-Downloading-icon3.png": 1363,
	"./Software-Downloading-icon4.png": 1364,
	"./Software-Downloading-img1.png": 1365,
	"./Software-Downloading-img2.png": 1366,
	"./Software-Downloading-img3.png": 1367,
	"./Software-Downloading-img4.png": 1368,
	"./a001-01.svg": 1369,
	"./a001-02.svg": 1370,
	"./a001-03.svg": 1371,
	"./a001-04.svg": 1372,
	"./a001-05.svg": 1373,
	"./a001-06.svg": 1374,
	"./a001-ransomware-01.png": 1375,
	"./a001-ransomware-02.png": 1376,
	"./a001-ransomware-03.png": 1377,
	"./a001-ransomware-04.png": 1378,
	"./a001-whatsapp-01.png": 1379,
	"./a001-whatsapp-02.png": 1380,
	"./a001-whatsapp-03.png": 1381,
	"./a004-a.jpg": 642,
	"./a004-b.jpg": 643,
	"./a004-example1-en.jpg": 644,
	"./a004-example1-sc.jpg": 645,
	"./a004-example1.jpg": 646,
	"./a004-example2.jpg": 647,
	"./a004-example3.jpg": 648,
	"./a004-mary-left.svg": 1382,
	"./a005-5.png": 1383,
	"./a005-6.png": 1384,
	"./a005-general2024.png": 1385,
	"./a006-a.png": 1386,
	"./a006-b.png": 1387,
	"./a006-c.png": 1388,
	"./a008-1.png": 1389,
	"./a008-1.svg": 1390,
	"./a008-2.png": 1391,
	"./a008-2.svg": 1392,
	"./a008-3.png": 1393,
	"./a008-3.svg": 1394,
	"./a008-4.png": 1395,
	"./a008-4.svg": 1396,
	"./a008-5.png": 1397,
	"./a008-5.svg": 1398,
	"./a008-6.svg": 1399,
	"./a008-7.svg": 1400,
	"./a008-A.svg": 1401,
	"./a008-B.svg": 1402,
	"./a008-C.svg": 1403,
	"./a008-D.svg": 1404,
	"./a008-tip.jpg": 649,
	"./a009-1.png": 1405,
	"./a009-1.svg": 1406,
	"./a009-2.png": 1407,
	"./a009-2.svg": 1408,
	"./a009-3.png": 1409,
	"./a009-3.svg": 1410,
	"./a009-4.png": 1411,
	"./a009-4.svg": 1412,
	"./a009-5.svg": 1413,
	"./a009-6.svg": 1414,
	"./a009-ransomware-01.svg": 1415,
	"./a009-ransomware-02.svg": 1416,
	"./a009-ransomware-03.svg": 1417,
	"./a009-ransomware-04.svg": 1418,
	"./a009-tip1.jpg": 650,
	"./a009-tip2.jpg": 651,
	"./a009-tip3.jpg": 652,
	"./a010-1.png": 1419,
	"./a010-2.png": 1420,
	"./a010-3.png": 1421,
	"./a010-4.png": 1422,
	"./a011-01.jpg": 653,
	"./a011-010.jpg": 654,
	"./a011-011.jpg": 655,
	"./a011-012.jpg": 656,
	"./a011-02.jpg": 657,
	"./a011-03.jpg": 658,
	"./a011-04.jpg": 659,
	"./a011-05.jpg": 660,
	"./a011-06.jpg": 661,
	"./a011-07.jpg": 662,
	"./a011-08.jpg": 663,
	"./a011-09.jpg": 664,
	"./a011-1.png": 1423,
	"./a011-1.svg": 1424,
	"./a011-2.png": 1425,
	"./a011-2.svg": 1426,
	"./a011-3.png": 1427,
	"./a011-3.svg": 1428,
	"./a011-4.png": 1429,
	"./a011-4.svg": 1430,
	"./a011-5.png": 1431,
	"./a011-5.svg": 1432,
	"./a011-6.png": 1433,
	"./a011-6.svg": 1434,
	"./a011-7.svg": 1435,
	"./a011-PPII-1.svg": 1436,
	"./a011-PPII-2.svg": 1437,
	"./a011-PPII-3.svg": 1438,
	"./a011-PPII-4.svg": 1439,
	"./a011-PPII-5.svg": 1440,
	"./a011-PPII-6.svg": 1441,
	"./a011-example1.jpg": 665,
	"./a011-example10.png": 1442,
	"./a011-example11_en.png": 1443,
	"./a011-example11_sc.png": 1444,
	"./a011-example11_tc.png": 1445,
	"./a011-example13_en.png": 1446,
	"./a011-example13_sc.png": 1447,
	"./a011-example13_tc.png": 1448,
	"./a011-example2.jpg": 666,
	"./a011-example3.jpg": 667,
	"./a011-example4.png": 1449,
	"./a011-example5.jpg": 668,
	"./a011-example6.jpg": 669,
	"./a011-example7.jpg": 670,
	"./a011-example8.jpg": 671,
	"./a011-example9.png": 1450,
	"./a011-fsi-01.svg": 1451,
	"./a011-fsi-02.svg": 1452,
	"./a011-fsi-03.svg": 1453,
	"./a011-fsi-04.svg": 1454,
	"./a011-fsi-05.svg": 1455,
	"./a011-fsi-06.svg": 1456,
	"./a011-fsi-07.svg": 1457,
	"./a011-fsi-08.svg": 1458,
	"./a011-fsi-09.svg": 1459,
	"./a011-fsi-10.svg": 1460,
	"./a011-general2024-example1.png": 1461,
	"./a011-general2024-example2.png": 1462,
	"./a011-general2024-example3.png": 1463,
	"./a011-general2024-example4.png": 1464,
	"./a011-market-1.svg": 1465,
	"./a011-market-2.svg": 1466,
	"./a011-market-3.svg": 1467,
	"./a011-market-4.svg": 1468,
	"./a011-market-5.svg": 1469,
	"./a011-market-6.svg": 1470,
	"./a011-startup-01.svg": 1471,
	"./a011-startup-02.svg": 1472,
	"./a011-startup-03.svg": 1473,
	"./a011-startup-04.svg": 1474,
	"./a011-startup-05.svg": 1475,
	"./a011-startup-06.svg": 1476,
	"./a011-startup-1.svg": 1477,
	"./a011-startup-2.svg": 1478,
	"./a011-startup-3.svg": 1479,
	"./a011-startup-4.svg": 1480,
	"./a011-startup-5.svg": 1481,
	"./a012-1.png": 1482,
	"./a012-1.svg": 1483,
	"./a012-10.png": 1484,
	"./a012-10.svg": 1485,
	"./a012-11.png": 1486,
	"./a012-12.png": 1487,
	"./a012-13.png": 1488,
	"./a012-14.png": 1489,
	"./a012-15.png": 1490,
	"./a012-2.png": 1491,
	"./a012-2.svg": 1492,
	"./a012-3.png": 1493,
	"./a012-3.svg": 1494,
	"./a012-4.png": 1495,
	"./a012-4.svg": 1496,
	"./a012-5.png": 1497,
	"./a012-5.svg": 1498,
	"./a012-6.png": 1499,
	"./a012-6.svg": 1500,
	"./a012-7.png": 1501,
	"./a012-7.svg": 1502,
	"./a012-8.png": 1503,
	"./a012-8.svg": 1504,
	"./a012-9.png": 1505,
	"./a012-9.svg": 1506,
	"./a012-market-1.svg": 1507,
	"./a012-market-10.svg": 1508,
	"./a012-market-2.svg": 1509,
	"./a012-market-3.svg": 1510,
	"./a012-market-4.svg": 1511,
	"./a012-market-5.svg": 1512,
	"./a012-market-6.svg": 1513,
	"./a012-market-7.svg": 1514,
	"./a012-market-8.svg": 1515,
	"./a012-market-9.svg": 1516,
	"./a012-market-line-1.svg": 1517,
	"./a012-market-line-10.svg": 1518,
	"./a012-market-line-2.svg": 1519,
	"./a012-market-line-3.svg": 1520,
	"./a012-market-line-4.svg": 1521,
	"./a012-market-line-5.svg": 1522,
	"./a012-market-line-6.svg": 1523,
	"./a012-market-line-7.svg": 1524,
	"./a012-market-line-8.svg": 1525,
	"./a012-market-line-9.svg": 1526,
	"./a013-1.png": 1527,
	"./a013-2.png": 1528,
	"./a013-3.png": 1529,
	"./a013-4.png": 1530,
	"./a013-a.png": 1531,
	"./a013-b.png": 1532,
	"./a013-c.png": 1533,
	"./a013-d.png": 1534,
	"./a014-long.svg": 1535,
	"./a014-longer.svg": 1536,
	"./a014.svg": 1537,
	"./a015-1.svg": 1538,
	"./a015-2.svg": 1539,
	"./a015-3.svg": 1540,
	"./a015-4.svg": 1541,
	"./a015-arrow.svg": 190,
	"./a016-1.jpg": 672,
	"./a016-2.jpg": 673,
	"./a016-3.jpg": 674,
	"./a016-4.jpg": 675,
	"./a016-4.png": 1542,
	"./a016-5.jpg": 676,
	"./a016-5.png": 1543,
	"./a016-6.jpg": 677,
	"./a016-6.png": 1544,
	"./a016-7.png": 1545,
	"./a016-8.png": 1546,
	"./a016-attention-market.svg": 191,
	"./a016-attention.svg": 192,
	"./a016-market-1.jpg": 678,
	"./a016-market-2.jpg": 679,
	"./a016-market-3.jpg": 680,
	"./a016-market-4.jpg": 681,
	"./a017-1.svg": 1547,
	"./a017-10.svg": 1548,
	"./a017-2.svg": 1549,
	"./a017-3.svg": 1550,
	"./a017-4.svg": 1551,
	"./a017-5.svg": 1552,
	"./a017-6.svg": 1553,
	"./a017-7.svg": 1554,
	"./a017-8.svg": 1555,
	"./a017-9.svg": 1556,
	"./a017-a.svg": 1557,
	"./a017-b.svg": 1558,
	"./a017-c.svg": 1559,
	"./a017-d.svg": 1560,
	"./a017-e.svg": 1561,
	"./a017-f.svg": 1562,
	"./a017-g.svg": 1563,
	"./a017-h.svg": 1564,
	"./a017-i.svg": 1565,
	"./a017-j.svg": 1566,
	"./a017-line1.svg": 1567,
	"./a017-line10.svg": 1568,
	"./a017-line2.svg": 1569,
	"./a017-line3.svg": 1570,
	"./a017-line4.svg": 1571,
	"./a017-line5.svg": 1572,
	"./a017-line6.svg": 1573,
	"./a017-line7.svg": 1574,
	"./a017-line8.svg": 1575,
	"./a017-line9.svg": 1576,
	"./a017-market-1.svg": 1577,
	"./a017-market-10.svg": 1578,
	"./a017-market-2.svg": 1579,
	"./a017-market-3.svg": 1580,
	"./a017-market-4.svg": 1581,
	"./a017-market-5.svg": 1582,
	"./a017-market-6.svg": 1583,
	"./a017-market-7.svg": 1584,
	"./a017-market-8.svg": 1585,
	"./a017-market-9.svg": 1586,
	"./a018-1.svg": 1587,
	"./a018-10.svg": 1588,
	"./a018-2.svg": 1589,
	"./a018-3.svg": 1590,
	"./a018-4.svg": 1591,
	"./a018-5.svg": 1592,
	"./a018-6.svg": 1593,
	"./a018-7.svg": 1594,
	"./a018-8.svg": 1595,
	"./a018-9.svg": 1596,
	"./a019-1.svg": 1597,
	"./a019-2.svg": 1598,
	"./a019-3.svg": 1599,
	"./a019-4.svg": 1600,
	"./a019-5.svg": 1601,
	"./a019-tip-en.jpg": 682,
	"./a019-tip.jpg": 683,
	"./a019.gif": 1602,
	"./a020-cs-1.svg": 1603,
	"./a020-cs-2.svg": 1604,
	"./a020-cs-3.svg": 1605,
	"./a020-cs-4.svg": 1606,
	"./a020-it-1.svg": 1607,
	"./a020-it-2.svg": 1608,
	"./a020-it-3.svg": 1609,
	"./a020-it-4.svg": 1610,
	"./a020-market-1.svg": 1611,
	"./a020-market-2.svg": 1612,
	"./a020-market-3.svg": 1613,
	"./a020-market-4.svg": 1614,
	"./a020-ngo-1.svg": 1615,
	"./a020-ngo-2.svg": 1616,
	"./a020-ngo-3.svg": 1617,
	"./a020-ngo-4.svg": 1618,
	"./a020-ngo-5.svg": 1619,
	"./a021-viewmore-en.jpg": 684,
	"./a021-viewmore-en.png": 1620,
	"./a021-viewmore-fsi.jpg": 685,
	"./a021-viewmore.jpg": 686,
	"./a021-viewmore.png": 1621,
	"./a022-market.svg": 1622,
	"./a023-01.png": 687,
	"./a023-02.png": 688,
	"./a023-03.png": 689,
	"./a023-04.png": 690,
	"./a023-05.png": 691,
	"./a023-06.png": 692,
	"./a023-1.png": 693,
	"./a023-2.png": 694,
	"./a023-3.png": 695,
	"./a023-4.png": 696,
	"./a023-example1.png": 697,
	"./a023-example2.png": 698,
	"./a023-example3.png": 699,
	"./a023-fsi1-short.png": 700,
	"./a023-fsi2-short.png": 701,
	"./a023-fsi3-short.png": 702,
	"./a023-fsi4-short.png": 703,
	"./a023-fsi5-short.png": 704,
	"./a023-short1.jpg": 263,
	"./a023-short2.jpg": 264,
	"./a023-short3.jpg": 265,
	"./a023-short4.jpg": 266,
	"./a023-short5.jpg": 267,
	"./a023-short6.jpg": 268,
	"./a023-startup1-en-short.png": 705,
	"./a023-startup1-en.png": 706,
	"./a023-startup1-short.png": 707,
	"./a023-startup1.png": 708,
	"./a023-startup2-en-short.png": 709,
	"./a023-startup2-en.png": 710,
	"./a023-startup2-short.png": 711,
	"./a023-startup2.png": 712,
	"./a023-startup3-en-short.png": 713,
	"./a023-startup3-en.png": 714,
	"./a023-startup3-short.png": 715,
	"./a023-startup3.png": 716,
	"./a023-startup4-en-short.png": 717,
	"./a023-startup4-en.png": 718,
	"./a023-startup4-short.png": 719,
	"./a023-startup4.png": 720,
	"./a023-startup5-en-short.png": 721,
	"./a023-startup5-en.png": 722,
	"./a023-startup5-short.png": 723,
	"./a023-startup5.png": 724,
	"./a024-1.gif": 1623,
	"./a024-1.svg": 1624,
	"./a024-10.svg": 1625,
	"./a024-11.svg": 1626,
	"./a024-12.svg": 1627,
	"./a024-2.gif": 1628,
	"./a024-2.svg": 1629,
	"./a024-3.svg": 1630,
	"./a024-4.svg": 1631,
	"./a024-5.svg": 1632,
	"./a024-6.svg": 1633,
	"./a024-7.svg": 1634,
	"./a024-8.svg": 1635,
	"./a024-9.svg": 1636,
	"./a024-startup-1.svg": 1637,
	"./a024-startup-2.svg": 1638,
	"./a024-startup-3.svg": 1639,
	"./a024-startup-4.svg": 1640,
	"./a024-startup-5.svg": 1641,
	"./a024-startup-6.svg": 1642,
	"./a026-example1-en.png": 1643,
	"./a026-example1.jpg": 725,
	"./a026-example2.jpg": 726,
	"./a026-example3.jpg": 727,
	"./a026-example4.jpg": 728,
	"./a026-example5.jpg": 729,
	"./a026-example6.jpg": 730,
	"./a026-example7.jpg": 731,
	"./a026-example8.png": 1644,
	"./a028-1.png": 732,
	"./a028-1.svg": 1645,
	"./a028-2.png": 733,
	"./a028-2.svg": 1646,
	"./a028-3.png": 734,
	"./a028-3.svg": 1647,
	"./a028-4.png": 735,
	"./a028-4.svg": 1648,
	"./a028-5.png": 736,
	"./a028-5.svg": 1649,
	"./a028-6.png": 737,
	"./a028-example1.jpg": 738,
	"./a028-example2.jpg": 739,
	"./a028-example3.jpg": 740,
	"./a033.png": 1650,
	"./a036-1.svg": 1651,
	"./a036-2.svg": 1652,
	"./a036-3.svg": 1653,
	"./a036-4.svg": 1654,
	"./a036-5.svg": 1655,
	"./a037-1.svg": 1656,
	"./a037-10.svg": 1657,
	"./a037-2.svg": 1658,
	"./a037-3.svg": 1659,
	"./a037-4.svg": 1660,
	"./a037-5.svg": 1661,
	"./a037-6.svg": 1662,
	"./a037-7.svg": 1663,
	"./a037-8.svg": 1664,
	"./a037-9.svg": 1665,
	"./a037-IDNumber-08.png": 1666,
	"./a037-a.jpg": 741,
	"./a037-address-02.png": 1667,
	"./a037-b.jpg": 742,
	"./a037-biometricData-10.png": 1668,
	"./a037-c.jpg": 743,
	"./a037-d.jpg": 744,
	"./a037-dateofBirth-05.png": 1669,
	"./a037-driverLicenseNumber-06.png": 1670,
	"./a037-e.jpg": 745,
	"./a037-emailAddress-04.png": 1671,
	"./a037-f.jpg": 746,
	"./a037-financialAccount-09.png": 1672,
	"./a037-g.jpg": 747,
	"./a037-h.jpg": 748,
	"./a037-i.jpg": 749,
	"./a037-j.jpg": 750,
	"./a037-k.jpg": 751,
	"./a037-l.jpg": 752,
	"./a037-m.jpg": 753,
	"./a037-n.jpg": 754,
	"./a037-name-01.png": 1673,
	"./a037-passportNumber-07.png": 1674,
	"./a037-phoneNumber-03.png": 1675,
	"./a037-student-1-en.png": 1676,
	"./a037-student-1-sc.png": 1677,
	"./a037-student-1.png": 1678,
	"./a037-student-2.png": 1679,
	"./a037-student-t3-1.svg": 1680,
	"./a037-student-t3-10.svg": 1681,
	"./a037-student-t3-2.svg": 1682,
	"./a037-student-t3-3.svg": 1683,
	"./a037-student-t3-4.svg": 1684,
	"./a037-student-t3-5.svg": 1685,
	"./a037-student-t3-6.svg": 1686,
	"./a037-student-t3-7.svg": 1687,
	"./a037-student-t3-8.svg": 1688,
	"./a037-student-t3-9.svg": 1689,
	"./a037-student-t3-s3-1.svg": 1690,
	"./a037-student-t3-s3-10.svg": 1691,
	"./a037-student-t3-s3-2.svg": 1692,
	"./a037-student-t3-s3-3.svg": 1693,
	"./a037-student-t3-s3-4.svg": 1694,
	"./a037-student-t3-s3-5.svg": 1695,
	"./a037-student-t3-s3-6.svg": 1696,
	"./a037-student-t3-s3-7.svg": 1697,
	"./a037-student-t3-s3-8.svg": 1698,
	"./a037-student-t3-s3-9.svg": 1699,
	"./a038-1.svg": 1700,
	"./a038-2.svg": 1701,
	"./a038-3.svg": 1702,
	"./a038-4.svg": 1703,
	"./a038-5.svg": 1704,
	"./a038-6.svg": 1705,
	"./a038-7.svg": 1706,
	"./a041-1.png": 1707,
	"./a041-2.png": 1708,
	"./a041-3.png": 1709,
	"./a041-4.png": 1710,
	"./a041-5.png": 1711,
	"./a041-fsi1-bottom.png": 1712,
	"./a041-fsi1-top.png": 1713,
	"./a041-fsi2-bottom.png": 1714,
	"./a041-fsi2-top.png": 1715,
	"./a041-fsi3-bottom.png": 1716,
	"./a041-fsi3-top.png": 1717,
	"./a041-fsi4-bottom.png": 1718,
	"./a041-fsi4-top.png": 1719,
	"./a041-fsi5-bottom.png": 1720,
	"./a041-fsi5-top.png": 1721,
	"./a044-1.png": 1722,
	"./a044-2.png": 1723,
	"./a044-3.png": 1724,
	"./a044-4.png": 1725,
	"./a044-5.png": 1726,
	"./a044-6.png": 1727,
	"./a046-1.png": 1728,
	"./a046-2.png": 1729,
	"./a046-3.png": 1730,
	"./a046-4.png": 1731,
	"./a046-5.png": 1732,
	"./a046-6.png": 1733,
	"./a047-icon1.png": 1734,
	"./a047-icon2.png": 1735,
	"./a047-icon3.png": 1736,
	"./a047-icon4.png": 1737,
	"./a047-icon5.png": 1738,
	"./a047-icon6.png": 1739,
	"./a047-icon7.png": 1740,
	"./a047-icon8.png": 1741,
	"./a047-vector-purple.png": 1742,
	"./a047-vector-red.png": 1743,
	"./a047-vector.png": 1744,
	"./aiSecurity.png": 1745,
	"./aiSecurityRealcase-en.jpg": 755,
	"./aiSecurityRealcase-mobile-en.jpg": 756,
	"./aiSecurityRealcase-mobile.jpg": 757,
	"./aiSecurityRealcase.jpg": 758,
	"./animation-arrow.gif": 98,
	"./animation-arrow10.gif": 1746,
	"./animation-arrow11.gif": 1747,
	"./animation-arrow12.gif": 1748,
	"./animation-arrow13.gif": 1749,
	"./animation-arrow2.gif": 1750,
	"./animation-arrow20.gif": 1751,
	"./animation-arrow26.gif": 1752,
	"./animation-arrow3.gif": 1753,
	"./animation-arrow4.gif": 1754,
	"./animation-arrow5.gif": 1755,
	"./animation-arrow6.gif": 1756,
	"./animation-arrow7.gif": 1757,
	"./animation-arrow8.gif": 1758,
	"./animation-arrow9.gif": 1759,
	"./animation-quiz.gif": 1760,
	"./animation004-1.png": 54,
	"./animation004-2.png": 1761,
	"./animation021-01.svg": 1762,
	"./animation021-02.svg": 1763,
	"./animation021-03.svg": 1764,
	"./animation021-04.svg": 1765,
	"./animation021-05.svg": 1766,
	"./animation021-06.svg": 1767,
	"./animation_password.gif": 1768,
	"./animation_password_en.gif": 1769,
	"./animation_point.gif": 4,
	"./arrow-left-long.png": 13,
	"./arrow-left.png": 133,
	"./arrow-right-long.png": 14,
	"./arrow-right.png": 134,
	"./arrow.png": 74,
	"./avater1.png": 1770,
	"./avater2.png": 1771,
	"./avater3.png": 1772,
	"./avater4.png": 1773,
	"./avater5.png": 1774,
	"./avater6.png": 53,
	"./avater7.png": 51,
	"./avater8.png": 1775,
	"./avater9.png": 1776,
	"./avaterStudent.svg": 1777,
	"./boss-right2.png": 1778,
	"./bp1.png": 1779,
	"./bp10.png": 1780,
	"./bp11.png": 1781,
	"./bp2.png": 1782,
	"./bp3.png": 1783,
	"./bp4.png": 1784,
	"./bp5.png": 1785,
	"./bp6.png": 1786,
	"./bp7.png": 1787,
	"./bp8.png": 1788,
	"./bp9.png": 1789,
	"./business-problem1-en.png": 1790,
	"./business-problem1-sc.png": 1791,
	"./business-problem1.png": 1792,
	"./business-problem2.gif": 1793,
	"./business-problem3.png": 1794,
	"./business-problem4-en.png": 1795,
	"./business-problem4.png": 1796,
	"./business-problem5-en.png": 1797,
	"./business-problem5-sc.png": 1798,
	"./business-problem5.png": 1799,
	"./c001-E-commerce-1.jpg": 759,
	"./c001-E-commerce-2.jpg": 760,
	"./c001-E-commerce-3.jpg": 761,
	"./c001-E-commerce-4.jpg": 762,
	"./c001-E-commerce-5.jpg": 763,
	"./c001-E-commerce-6.jpg": 764,
	"./c001-Picture1.jpg": 765,
	"./c001-Picture2.jpg": 766,
	"./c001-Picture3.jpg": 767,
	"./c001-fsi-1.jpg": 768,
	"./c001-fsi-2.jpg": 769,
	"./c001-fsi-3.jpg": 770,
	"./c001-fsi-4.jpg": 771,
	"./c001-general2024-1.png": 1800,
	"./c001-general2024-2.png": 1801,
	"./c001-general2024-3.png": 1802,
	"./c001-general2024-4.png": 1803,
	"./c001-general2024-5.png": 1804,
	"./c001-general2024-6.png": 1805,
	"./c001-general2024-7.png": 1806,
	"./c001-general2024-8.png": 1807,
	"./c001-ngo-1.jpg": 772,
	"./c001-ngo-2.jpg": 773,
	"./c001-ngo-3.jpg": 774,
	"./c001-ngo-4.jpg": 775,
	"./c001-ngo-5.jpg": 776,
	"./c001-student-1.jpg": 777,
	"./c001-student-2.jpg": 778,
	"./c001-student-3.jpg": 779,
	"./c001-student-4.jpg": 780,
	"./c001-student-5.jpg": 781,
	"./c001-student-6.jpg": 782,
	"./c001-student-7.jpg": 783,
	"./c001-student-8.jpg": 784,
	"./c002-1.png": 1808,
	"./c002-1.svg": 1809,
	"./c002-PPII-1.svg": 1810,
	"./c002-PPII-10.svg": 1811,
	"./c002-PPII-11.svg": 1812,
	"./c002-PPII-12.svg": 1813,
	"./c002-PPII-13.svg": 1814,
	"./c002-PPII-14.svg": 1815,
	"./c002-PPII-15.svg": 1816,
	"./c002-PPII-16.svg": 1817,
	"./c002-PPII-2.svg": 1818,
	"./c002-PPII-3.svg": 1819,
	"./c002-PPII-4.svg": 1820,
	"./c002-PPII-6.svg": 1821,
	"./c002-PPII-7.svg": 1822,
	"./c002-PPII-8.svg": 1823,
	"./c002-PPII-9.svg": 1824,
	"./c002-eCommerce.png": 1825,
	"./c002-example1.jpg": 785,
	"./c002-general2024-example1.jpg": 786,
	"./c002-pic.png": 1826,
	"./c002-whatsapp-01-en.png": 1827,
	"./c002-whatsapp-01.png": 1828,
	"./c002-whatsapp-02-en.png": 1829,
	"./c002-whatsapp-02.png": 1830,
	"./c003-man-left.png": 1831,
	"./c003-right-lady.png": 1832,
	"./c005-1.png": 1833,
	"./c005-10.png": 1834,
	"./c005-11.png": 1835,
	"./c005-12.png": 1836,
	"./c005-13.png": 1837,
	"./c005-2.png": 1838,
	"./c005-3.png": 1839,
	"./c005-4.png": 1840,
	"./c005-5.png": 1841,
	"./c005-6.png": 1842,
	"./c005-7.png": 1843,
	"./c005-8.png": 1844,
	"./c005-9.png": 1845,
	"./c005-arrow01.png": 410,
	"./c005-arrow02.png": 411,
	"./c005-whatsapp-01-en.png": 1846,
	"./c005-whatsapp-01.png": 1847,
	"./c005-whatsapp-02-en.png": 1848,
	"./c005-whatsapp-02.png": 1849,
	"./c005-whatsapp-03-en.png": 1850,
	"./c005-whatsapp-03.png": 1851,
	"./c006-1.jpg": 787,
	"./c006-2.jpg": 788,
	"./c006-3.jpg": 789,
	"./c006-4.jpg": 790,
	"./c006-5.gif": 1852,
	"./c006-5.jpg": 791,
	"./c006-6.gif": 1853,
	"./c006-6.jpg": 792,
	"./c006-a.jpg": 793,
	"./c006-b.jpg": 794,
	"./c006-b.png": 1854,
	"./c006-c.jpg": 795,
	"./c006-c.png": 1855,
	"./c006-d.jpg": 796,
	"./c007-1.jpg": 797,
	"./c007-bg.jpg": 798,
	"./c008-1.png": 1856,
	"./c008-2.png": 1857,
	"./c008-2.svg": 1858,
	"./c008-3.svg": 1859,
	"./c008-board.svg": 1860,
	"./c008-board1.svg": 1861,
	"./c010-1.png": 1862,
	"./c010-2.png": 1863,
	"./c010-3.png": 1864,
	"./c010-4.png": 1865,
	"./c013-1.png": 1866,
	"./c013-2.png": 1867,
	"./calendar.png": 412,
	"./can-do.png": 1868,
	"./can-do.svg": 1869,
	"./can-do1.png": 1870,
	"./can-not-do.png": 1871,
	"./ceritificate-background.png": 1872,
	"./cert/cert-E-commerce-HKIRC.jpg": 799,
	"./cert/cert-E-commerce-consumer.jpg": 800,
	"./cert/cert-E-commerce-cpttm.jpg": 269,
	"./cert/cert-E-commerce-hkgcsmeaa.jpg": 801,
	"./cert/cert-customer-HKIRC.jpg": 802,
	"./cert/cert-customer-consumer.jpg": 803,
	"./cert/cert-customer-cpttm.jpg": 270,
	"./cert/cert-customer-hkgcsmeaa.jpg": 804,
	"./cert/cert-finance-HKIRC-sc.jpg": 805,
	"./cert/cert-finance-HKIRC.jpg": 806,
	"./cert/cert-finance-consumer-sc.jpg": 807,
	"./cert/cert-finance-consumer.jpg": 808,
	"./cert/cert-finance-cpttm-sc.jpg": 271,
	"./cert/cert-finance-cpttm.jpg": 272,
	"./cert/cert-finance-hkgcsmeaa-sc.jpg": 809,
	"./cert/cert-finance-hkgcsmeaa.jpg": 810,
	"./cert/cert-fsi-HKIRC-sc.jpg": 811,
	"./cert/cert-fsi-HKIRC.jpg": 812,
	"./cert/cert-fsi-consumer-sc.jpg": 813,
	"./cert/cert-fsi-consumer.jpg": 814,
	"./cert/cert-fsi-cpttm-sc.jpg": 273,
	"./cert/cert-fsi-cpttm.jpg": 274,
	"./cert/cert-fsi-hkgcsmeaa-sc.jpg": 815,
	"./cert/cert-fsi-hkgcsmeaa.jpg": 816,
	"./cert/cert-general-staff-HKIRC-sc.jpg": 817,
	"./cert/cert-general-staff-HKIRC.jpg": 818,
	"./cert/cert-general-staff-a-HKIRC-sc.jpg": 819,
	"./cert/cert-general-staff-a-HKIRC.jpg": 820,
	"./cert/cert-general-staff-a-consumer-sc.jpg": 821,
	"./cert/cert-general-staff-a-consumer.jpg": 822,
	"./cert/cert-general-staff-a-cpttm-sc.jpg": 275,
	"./cert/cert-general-staff-a-cpttm.jpg": 276,
	"./cert/cert-general-staff-a-hkgcsmeaa-sc.jpg": 823,
	"./cert/cert-general-staff-a-hkgcsmeaa.jpg": 824,
	"./cert/cert-general-staff-consumer-sc.jpg": 825,
	"./cert/cert-general-staff-consumer.jpg": 826,
	"./cert/cert-general-staff-cpttm-sc.jpg": 277,
	"./cert/cert-general-staff-cpttm.jpg": 278,
	"./cert/cert-general-staff-hkgcsmeaa-sc.jpg": 827,
	"./cert/cert-general-staff-hkgcsmeaa.jpg": 828,
	"./cert/cert-general2024-HKIRC-sc.jpg": 829,
	"./cert/cert-general2024-HKIRC.jpg": 830,
	"./cert/cert-general2024-consumer-sc.jpg": 831,
	"./cert/cert-general2024-consumer.jpg": 832,
	"./cert/cert-general2024-cpttm-sc.jpg": 207,
	"./cert/cert-general2024-cpttm.jpg": 208,
	"./cert/cert-general2024-hkgcsmeaa-sc.jpg": 833,
	"./cert/cert-general2024-hkgcsmeaa.jpg": 834,
	"./cert/cert-hr-HKIRC.jpg": 835,
	"./cert/cert-hr-consumer.jpg": 836,
	"./cert/cert-hr-cpttm.jpg": 279,
	"./cert/cert-hr-hkgcsmeaa.jpg": 837,
	"./cert/cert-it-HKIRC.jpg": 838,
	"./cert/cert-it-consumer.jpg": 839,
	"./cert/cert-it-cpttm.jpg": 280,
	"./cert/cert-it-hkgcsmeaa.jpg": 840,
	"./cert/cert-market-HKIRC.jpg": 841,
	"./cert/cert-market-consumer.jpg": 842,
	"./cert/cert-market-cpttm.jpg": 281,
	"./cert/cert-market-hkgcsmeaa.jpg": 843,
	"./cert/cert-ngo-HKIRC.jpg": 844,
	"./cert/cert-ngo-consumer.jpg": 845,
	"./cert/cert-ngo-cpttm.jpg": 282,
	"./cert/cert-ngo-hkgcsmeaa.jpg": 846,
	"./cert/cert-senior-manager-HKIRC-sc.jpg": 847,
	"./cert/cert-senior-manager-HKIRC.jpg": 848,
	"./cert/cert-senior-manager-consumer-sc.jpg": 849,
	"./cert/cert-senior-manager-consumer.jpg": 850,
	"./cert/cert-senior-manager-cpttm-sc.jpg": 283,
	"./cert/cert-senior-manager-cpttm.jpg": 284,
	"./cert/cert-senior-manager-hkgcsmeaa-sc.jpg": 851,
	"./cert/cert-senior-manager-hkgcsmeaa.jpg": 852,
	"./cert/cert-startup-HKIRC.jpg": 853,
	"./cert/cert-startup-consumer.jpg": 854,
	"./cert/cert-startup-cpttm.jpg": 285,
	"./cert/cert-startup-hkgcsmeaa.jpg": 855,
	"./cert/cert-student-HKIRC-sc.jpg": 856,
	"./cert/cert-student-HKIRC.jpg": 857,
	"./cert/cert-student-consumer-sc.jpg": 858,
	"./cert/cert-student-consumer.jpg": 859,
	"./cert/cert-student-cpttm-sc.jpg": 286,
	"./cert/cert-student-cpttm.jpg": 287,
	"./cert/cert-student-hkgcsmeaa-sc.jpg": 860,
	"./cert/cert-student-hkgcsmeaa.jpg": 861,
	"./chat.gif": 1873,
	"./component003-left.png": 36,
	"./component003-right.png": 37,
	"./component003Boss-left.png": 1874,
	"./component003Boss-right.png": 1875,
	"./component003Lady-right.png": 1876,
	"./component003Man-right.png": 1877,
	"./component003Student-right.svg": 1878,
	"./contacting.png": 1879,
	"./conversation-left.png": 28,
	"./conversation-right.png": 26,
	"./conversation-right2.png": 1880,
	"./courseLanding-PPII.png": 1881,
	"./courseLanding-aiSecurity.png": 1882,
	"./courseLanding-dataLeakage.png": 1883,
	"./courseLanding-ransomware-mobile.png": 1884,
	"./courseLanding-ransomware.png": 1885,
	"./courseLanding-socialMedia.png": 1886,
	"./courseLanding-whatsApp.png": 1887,
	"./courses/Finance.png": 1888,
	"./courses/Finance2.png": 1889,
	"./courses/GeneralStaff_Background.svg": 1890,
	"./courses/HR.png": 1891,
	"./courses/HotTopic_Background.svg": 1892,
	"./courses/IndustrySector_Background.svg": 1893,
	"./courses/JobPosition_Background.svg": 1894,
	"./courses/Manufacturing.png": 1895,
	"./courses/Ransomeware.png": 1896,
	"./courses/Retails.png": 1897,
	"./courses/Senior.png": 1898,
	"./courses/course1.png": 1899,
	"./courses/course10.png": 1900,
	"./courses/course8.png": 1901,
	"./courses/gf-topic1.png": 1902,
	"./cover.png": 1903,
	"./cs-a009-1.svg": 1904,
	"./cs-a009-2.svg": 1905,
	"./cs-a009-3.svg": 1906,
	"./cs-a009-4.svg": 1907,
	"./cs-a009-5.svg": 1908,
	"./cs-a009-6.svg": 1909,
	"./cs-a018-1.svg": 1910,
	"./cs-a018-10.svg": 1911,
	"./cs-a018-11.svg": 1912,
	"./cs-a018-2.svg": 1913,
	"./cs-a018-3.svg": 1914,
	"./cs-a018-4.svg": 1915,
	"./cs-a018-5.svg": 1916,
	"./cs-a018-6.svg": 1917,
	"./cs-a018-7.svg": 1918,
	"./cs-a018-8.svg": 1919,
	"./cs-a018-9.svg": 1920,
	"./cs-c001-Picture1.png": 1921,
	"./cs-c001-Picture2.png": 1922,
	"./cs-c001-Picture3.png": 1923,
	"./cs-c001-Picture4.png": 1924,
	"./cs-c003-boss-right.svg": 1925,
	"./cs-c003-right.svg": 1926,
	"./cs-gif1.gif": 1927,
	"./cs-gif2.gif": 1928,
	"./cs-gif3.gif": 1929,
	"./cs-gif4.gif": 1930,
	"./cs-welcome.svg": 1931,
	"./cyber-phishing1.png": 1932,
	"./cyber-phishing2.png": 1933,
	"./cyber-phishing3.png": 1934,
	"./cyber-phishing4.png": 1935,
	"./dataLeakage.png": 1936,
	"./dataLeakageRealcase-en.jpg": 862,
	"./dataLeakageRealcase-mobile-en.jpg": 863,
	"./dataLeakageRealcase-mobile.jpg": 864,
	"./dataLeakageRealcase.jpg": 865,
	"./desk-clean-icon1.png": 1937,
	"./desk-clean-icon2.png": 1938,
	"./desk-clean-icon3.png": 1939,
	"./desk-clean-icon4.png": 1940,
	"./desk-clean-img1.png": 1941,
	"./desk-clean-img2.png": 1942,
	"./desk-clean-img3.png": 1943,
	"./desk-clean-img4.png": 1944,
	"./desk-clean1.png": 1945,
	"./desk-clean2.png": 1946,
	"./desk-clean3.png": 1947,
	"./desk-clean4.png": 1948,
	"./desk-clean5.png": 1949,
	"./education/close_icon.png": 413,
	"./education/cybersecurity/arrow-right-circle.png": 414,
	"./education/cybersecurity/bg-light.png": 1950,
	"./education/cybersecurity/bg1.png": 1951,
	"./education/cybersecurity/bg2.png": 1952,
	"./education/cybersecurity/bg3.png": 1953,
	"./education/cybersecurity/bg4.png": 1954,
	"./education/cybersecurity/bg5.png": 1955,
	"./education/cybersecurity/bg6.png": 1956,
	"./education/cybersecurity/bg7.png": 1957,
	"./education/cybersecurity/chat-bg-h5.png": 1958,
	"./education/cybersecurity/chat-bg-pc.png": 1959,
	"./education/cybersecurity/chatBg.png": 1960,
	"./education/cybersecurity/h5-bg/case-study-center.png": 1961,
	"./education/cybersecurity/h5-bg/case-study-left.png": 1962,
	"./education/cybersecurity/h5-bg/case-study-right.png": 1963,
	"./education/cybersecurity/h5-bg/case-study-tips.png": 1964,
	"./education/cybersecurity/h5-bg/h5-bg1.png": 1965,
	"./education/cybersecurity/h5-bg/h5-bg2.png": 1966,
	"./education/cybersecurity/h5-bg/h5-bg3.png": 1967,
	"./education/cybersecurity/h5-bg/h5-bg4.png": 1968,
	"./education/cybersecurity/h5-bg/h5-bg5.png": 1969,
	"./education/cybersecurity/h5-bg/h5-bg6.png": 1970,
	"./education/cybersecurity/h5-bg/h5-bg7.png": 1971,
	"./education/cybersecurity/h5-bg/h5-bg8.png": 1972,
	"./education/cybersecurity/h5-bg/h5-pic-bg1.png": 1973,
	"./education/cybersecurity/h5-bg/process-bg.png": 1974,
	"./education/cybersecurity/h5-bg/section-process-1.png": 1975,
	"./education/cybersecurity/h5-bg/section-process-2.png": 1976,
	"./education/cybersecurity/h5-bg/section-process-3.png": 1977,
	"./education/cybersecurity/h5-bg/section-process-4.png": 1978,
	"./education/cybersecurity/icon-award.png": 415,
	"./education/cybersecurity/icon-book-open.png": 416,
	"./education/cybersecurity/icon-cast.png": 417,
	"./education/cybersecurity/icon-chevrons up.png": 418,
	"./education/cybersecurity/icon-clock.png": 419,
	"./education/cybersecurity/icon-command.png": 420,
	"./education/cybersecurity/message-bg.png": 1979,
	"./education/cybersecurity/message-bg.svg": 1980,
	"./education/cybersecurity/num-01.svg": 421,
	"./education/cybersecurity/num-02.svg": 422,
	"./education/cybersecurity/num-03.svg": 423,
	"./education/cybersecurity/num-04.svg": 424,
	"./education/cybersecurity/num-05.svg": 425,
	"./education/cybersecurity/num-icon-bg.png": 426,
	"./education/cybersecurity/num-icon1.svg": 427,
	"./education/cybersecurity/num-icon2.svg": 428,
	"./education/cybersecurity/num-icon3.svg": 429,
	"./education/cybersecurity/num-icon4.svg": 430,
	"./education/cybersecurity/num-icon5.svg": 431,
	"./education/cybersecurity/plan-bg.svg": 1981,
	"./education/cybersecurity/plan-pic-bg-h5.png": 1982,
	"./education/cybersecurity/plan-pic.png": 432,
	"./education/cybersecurity/question-bg.png": 1983,
	"./education/cybersecurity/section-process-bg1.png": 1984,
	"./education/cybersecurity/section-process-bg2.png": 1985,
	"./education/cybersecurity/section-process-bg3.png": 1986,
	"./education/cybersecurity/section-process-bg4.png": 1987,
	"./education/cybersecurity/section0-bg1.png": 433,
	"./education/cybersecurity/section0-bg2.png": 434,
	"./education/cybersecurity/section0-bg3.png": 1988,
	"./education/cybersecurity/section1-bg-h5.png": 1989,
	"./education/cybersecurity/section1-bg1.png": 435,
	"./education/cybersecurity/section1-bg2.svg": 1990,
	"./education/cybersecurity/section1-bg3-h5.png": 1991,
	"./education/cybersecurity/section1-bg3.svg": 1992,
	"./education/cybersecurity/section1-bg4.svg": 1993,
	"./education/cybersecurity/section1-measure1.svg": 1994,
	"./education/cybersecurity/section1-measure2.svg": 1995,
	"./education/cybersecurity/section1-measure3.svg": 1996,
	"./education/cybersecurity/section1-process-bg.png": 1997,
	"./education/cybersecurity/section1-process-bg1.png": 436,
	"./education/cybersecurity/section1-process-bg2.png": 437,
	"./education/cybersecurity/union.png": 1998,
	"./education/error_bg.png": 1999,
	"./education/ot/background-left.png": 2000,
	"./education/ot/bubble_bg.png": 2001,
	"./education/ot/guide_bg.png": 2002,
	"./education/ot/guide_bg_top.png": 2003,
	"./education/ot/guide_bg_y.png": 2004,
	"./education/ot/h5_guide_bg_top.png": 2005,
	"./education/ot/header-bg.png": 2006,
	"./education/ot/icon/icon1.png": 438,
	"./education/ot/icon/icon2.png": 439,
	"./education/ot/icon/icon3.png": 440,
	"./education/ot/icon/icon4.png": 441,
	"./education/ot/icon/icon5.png": 442,
	"./education/ot/icon/icon6.png": 443,
	"./education/ot/m_background-left.png": 2007,
	"./education/ot/ot_quiz_bg.png": 2008,
	"./education/ot/person.png": 444,
	"./education/ot/picture/img1.png": 445,
	"./education/ot/picture/img2.png": 446,
	"./education/ot/picture/img3.png": 447,
	"./education/ot/picture/img4.png": 448,
	"./education/ot/picture/img5.png": 449,
	"./education/ot/picture/img6.png": 450,
	"./education/ot/section0_bg.png": 2009,
	"./education/ot/section1_bg.png": 2010,
	"./education/ot/section2_bg.png": 2011,
	"./education/ot/section2_bg_1.png": 2012,
	"./education/ot/section2_bg_2.png": 2013,
	"./education/ot/tools-bj-bottom.png": 2014,
	"./education/ot/tools-bj-top.png": 2015,
	"./education/ot/welcome_bg_bubble.png": 2016,
	"./education/ptm/ai-bg.png": 2017,
	"./education/ptm/ai_left_bg.png": 451,
	"./education/ptm/ai_right_bg.png": 452,
	"./education/ptm/bubble/bubble1.png": 2018,
	"./education/ptm/bubble/bubble3.png": 2019,
	"./education/ptm/bubble/bubble4.png": 2020,
	"./education/ptm/bubble/bubble6.png": 2021,
	"./education/ptm/bubble/m_bubble1.png": 2022,
	"./education/ptm/bubble/m_bubble3.png": 2023,
	"./education/ptm/bubble/m_bubble4.png": 2024,
	"./education/ptm/bubble/m_bubble6.png": 2025,
	"./education/ptm/bubble_bg.png": 2026,
	"./education/ptm/factor/factor_bubble.png": 2027,
	"./education/ptm/factor/factor_item_1.png": 2028,
	"./education/ptm/factor/factor_item_2.png": 2029,
	"./education/ptm/factor/factor_item_3.png": 2030,
	"./education/ptm/factor/factor_item_4.png": 2031,
	"./education/ptm/factor/m_factor_item_1.png": 2032,
	"./education/ptm/factor/m_factor_item_2.png": 2033,
	"./education/ptm/factor/m_factor_item_3.png": 2034,
	"./education/ptm/factor/m_factor_item_4.png": 2035,
	"./education/ptm/factor_left_bg.png": 2036,
	"./education/ptm/factor_right_bg.png": 453,
	"./education/ptm/light.png": 193,
	"./education/ptm/m_ai_bg.png": 2037,
	"./education/ptm/m_bubble_bg.png": 2038,
	"./education/ptm/m_ptm_bg_2.png": 2039,
	"./education/ptm/m_welcome_bg_bubble.png": 2040,
	"./education/ptm/person.png": 454,
	"./education/ptm/practice_left_bg.png": 455,
	"./education/ptm/practice_right_bg.png": 456,
	"./education/ptm/practice_top_bg.png": 457,
	"./education/ptm/ptm_bg_1.png": 2041,
	"./education/ptm/ptm_bg_2.png": 2042,
	"./education/ptm/ptm_quiz_bg.png": 2043,
	"./education/ptm/q_right_bg.png": 458,
	"./education/ptm/use/m_use_action_back_cz.png": 2044,
	"./education/ptm/use/m_use_action_back_hk.png": 2045,
	"./education/ptm/use/m_use_action_back_xw.png": 2046,
	"./education/ptm/use/m_use_action_back_zc.png": 2047,
	"./education/ptm/use/m_use_action_cz.png": 2048,
	"./education/ptm/use/m_use_action_hk.png": 2049,
	"./education/ptm/use/m_use_action_xw.png": 2050,
	"./education/ptm/use/m_use_action_zc.png": 2051,
	"./education/ptm/use/use_action_back_cz.png": 2052,
	"./education/ptm/use/use_action_back_hk.png": 2053,
	"./education/ptm/use/use_action_back_xw.png": 2054,
	"./education/ptm/use/use_action_back_zc.png": 2055,
	"./education/ptm/use/use_action_cz.png": 2056,
	"./education/ptm/use/use_action_hk.png": 2057,
	"./education/ptm/use/use_action_xw.png": 2058,
	"./education/ptm/use/use_action_zc.png": 2059,
	"./education/ptm/welcome_bg.png": 2060,
	"./education/ptm/welcome_bg_bottom.png": 2061,
	"./education/ptm/welcome_bg_bubble.png": 2062,
	"./education/quiz/again_icon.png": 459,
	"./education/quiz/answer_left.png": 460,
	"./education/quiz/correct_icon.png": 461,
	"./education/quiz/downward_icon.png": 462,
	"./education/quiz/error_icon.png": 463,
	"./education/quiz/m_quiz_bg.png": 2063,
	"./education/quiz/m_quiz_bg_1.png": 2064,
	"./education/quiz/m_review_top_bg.png": 2065,
	"./education/quiz/no_pass_bg.png": 2066,
	"./education/quiz/no_pass_person.png": 464,
	"./education/quiz/no_pass_word_bg.png": 2067,
	"./education/quiz/pass_bg.png": 2068,
	"./education/quiz/pass_download.png": 465,
	"./education/quiz/pass_person.png": 466,
	"./education/quiz/pass_word_bg.png": 2069,
	"./education/quiz/quiz_bg.png": 2070,
	"./education/quiz/quiz_bg_1.png": 2071,
	"./education/quiz/review_bg.png": 2072,
	"./education/quiz/review_top_bg.png": 2073,
	"./education/quiz/smile.png": 467,
	"./education/quiz/upset.png": 468,
	"./education/quiz_bg.png": 2074,
	"./education/quiz_mask.png": 2075,
	"./education/right_bg.png": 2076,
	"./education/topic1000/Interacting1.png": 469,
	"./education/topic1000/Interacting2.png": 470,
	"./education/topic1000/arrow.svg": 2077,
	"./education/topic1000/bg1.png": 2078,
	"./education/topic1000/bg2.png": 2079,
	"./education/topic1000/bg3.png": 2080,
	"./education/topic1000/bg4.png": 2081,
	"./education/topic1000/bubble/bubble1.png": 2082,
	"./education/topic1000/bubble/bubble3.png": 2083,
	"./education/topic1000/bubble/bubble4.png": 2084,
	"./education/topic1000/bubble/bubble6.png": 2085,
	"./education/topic1000/case-study-h5.png": 2086,
	"./education/topic1000/h5-bg/collapse-bg.png": 2087,
	"./education/topic1000/h5-bg/h5-section2-bg1.png": 2088,
	"./education/topic1000/h5-bg/h5-section2-bg2.png": 2089,
	"./education/topic1000/h5-bg/h5-section2-bg3.png": 2090,
	"./education/topic1000/h5-bg/h5-section2-bg4.png": 2091,
	"./education/topic1000/link1-1.png": 471,
	"./education/topic1000/link1.png": 472,
	"./education/topic1000/link2.png": 473,
	"./education/topic1000/link3.png": 474,
	"./education/topic1000/panelData1.png": 475,
	"./education/topic1000/panelData2.png": 476,
	"./education/topic1000/panelData3.png": 477,
	"./education/topic1000/panelData4.jpg": 223,
	"./education/topic1000/panelData5.png": 478,
	"./education/topic1000/panelData6.jpg": 224,
	"./education/topic1000/phishing/bg.svg": 2092,
	"./education/topic1000/phishing/bubble_bg.svg": 479,
	"./education/topic1000/phishing/chatBg.png": 2093,
	"./education/topic1000/phishing/chatBg2.png": 2094,
	"./education/topic1000/phishing/icon1.svg": 480,
	"./education/topic1000/phishing/icon2.svg": 481,
	"./education/topic1000/phishing/icon3.svg": 482,
	"./education/topic1000/phishing/icon4.svg": 483,
	"./education/topic1000/phishing/icon5.svg": 484,
	"./education/topic1000/phishing/icon6.svg": 485,
	"./education/topic1000/phishing/pic1.svg": 2095,
	"./education/topic1000/phishing/questionBg.png": 2096,
	"./education/topic1000/phishing/tab1.svg": 2097,
	"./education/topic1000/phishing/tab2.svg": 2098,
	"./education/topic1000/phishing/title_bg.svg": 2099,
	"./education/topic1000/seciton3_icon.svg": 2100,
	"./education/topic1000/section1_footer_bg.png": 486,
	"./education/topic1000/section1_tool.png": 2101,
	"./education/topic1000/section1_tool1.png": 2102,
	"./education/topic1000/section1_tool_bubble.svg": 2103,
	"./education/topic1000/section3-bg-left.png": 2104,
	"./education/topic1000/section3_bg2.svg": 487,
	"./education/topic1000/section3_bg3.png": 488,
	"./education/topic1000/section3_bg4.png": 2105,
	"./education/topic1000/section3_bg5.png": 2106,
	"./education/topic1000/step-h5-bg.png": 2107,
	"./education/topic1000/tool-pic/tool-item-h5-bg1.png": 2108,
	"./education/topic1000/tool-pic/tool-item-h5-bg2.png": 2109,
	"./education/topic1000/tool-pic/tool-item-h5-bg3.png": 2110,
	"./education/topic1000/tool-pic/tool-item-h5-bg4.png": 2111,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg1.png": 2112,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg2.png": 2113,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg3.png": 2114,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg4.png": 2115,
	"./education/topic1000/tool-pic/tool_bubble.png": 2116,
	"./education/topic1000/tool-pic/tool_bubble_blue.png": 2117,
	"./education/topic1000/tool-pic/tool_item_1.png": 2118,
	"./education/topic1000/tool-pic/tool_item_2.png": 2119,
	"./education/topic1000/tool-pic/tool_item_3.png": 2120,
	"./education/topic1000/tool-pic/tool_item_4.png": 2121,
	"./education/topic1000/tool-pic/tool_item_blue1.png": 2122,
	"./education/topic1000/tool-pic/tool_item_blue2.png": 2123,
	"./education/topic1000/tool-pic/tool_item_blue3.png": 2124,
	"./education/topic1000/tool-pic/tool_item_blue4.png": 2125,
	"./education/topic900/bg-light.png": 2126,
	"./education/topic900/bg-orange.png": 2127,
	"./education/topic900/bg-priority.png": 2128,
	"./education/topic900/bg-white.png": 2129,
	"./education/topic900/bg1.png": 2130,
	"./education/topic900/bg2.png": 2131,
	"./education/topic900/bg3.png": 2132,
	"./education/topic900/bg4.png": 2133,
	"./education/topic900/chatBg.png": 2134,
	"./education/topic900/cyber-policy-bg.png": 2135,
	"./education/topic900/h5-bg/h5-section1-bg1.png": 2136,
	"./education/topic900/h5-bg/h5-section1-bg2.png": 2137,
	"./education/topic900/h5-bg/h5-section1-bg3.png": 2138,
	"./education/topic900/h5-bg/h5-section1-bg4.png": 2139,
	"./education/topic900/h5-bg/h5-section1-bg5.png": 2140,
	"./education/topic900/h5-bg/h5-section1-bg6.png": 2141,
	"./education/topic900/h5-bg/h5-section1-pic1.png": 2142,
	"./education/topic900/h5-bg/h5-section1-step.png": 2143,
	"./education/topic900/h5-bg/h5-section1-tip1.png": 2144,
	"./education/topic900/ot_quiz_bg.png": 2145,
	"./education/topic900/person.svg": 489,
	"./education/topic900/priority.png": 2146,
	"./education/topic900/priority_icon1.png": 490,
	"./education/topic900/priority_icon2.png": 491,
	"./education/topic900/priority_icon3.svg": 492,
	"./education/topic900/right-circle.png": 235,
	"./education/topic900/section1_1.png": 194,
	"./education/topic900/section1_2.png": 2147,
	"./education/topic900/section2_1.svg": 493,
	"./education/topic900/section2_2.png": 2148,
	"./education/topic900/section2_3.svg": 2149,
	"./education/topic900/section3_bg.svg": 2150,
	"./education/topic900/step.png": 2151,
	"./education/topic900/step1.png": 2152,
	"./education/topic900/step1.svg": 2153,
	"./education/topic900/step11.png": 494,
	"./education/topic900/step2.png": 2154,
	"./education/topic900/step2.svg": 2155,
	"./education/topic900/step22.png": 495,
	"./education/topic900/step3.png": 496,
	"./education/topic900/step3.svg": 2156,
	"./education/topic900/step4.png": 497,
	"./education/topic900/topic900_bg1.png": 498,
	"./education/topic900/topic900_bg2.png": 499,
	"./education/topic900/topic900_tip.svg": 2157,
	"./education/welcome/five.png": 500,
	"./education/welcome/folder.png": 2158,
	"./education/welcome/four.png": 501,
	"./education/welcome/highway.png": 2159,
	"./education/welcome/line.png": 502,
	"./education/welcome/m_five.png": 503,
	"./education/welcome/m_four.png": 504,
	"./education/welcome/m_highway.png": 2160,
	"./education/welcome/m_two.png": 505,
	"./education/welcome/m_welcome_bg.png": 2161,
	"./education/welcome/one.png": 506,
	"./education/welcome/person.png": 2162,
	"./education/welcome/record.png": 2163,
	"./education/welcome/three.png": 507,
	"./education/welcome/two.png": 508,
	"./education/welcome/vase.png": 2164,
	"./education/welcome/welcome_bg.png": 2165,
	"./equal-highlight.png": 509,
	"./equal.png": 510,
	"./filterArrow.svg": 511,
	"./finance-gif1.gif": 2166,
	"./finance-gif2.gif": 2167,
	"./finance-gif3.gif": 2168,
	"./finance-gif4.gif": 2169,
	"./finance-topic1.png": 2170,
	"./finance-topic2.png": 2171,
	"./finance-topic3.png": 2172,
	"./finance-topic4.png": 2173,
	"./flame-training.gif": 2174,
	"./fonts/02b3f97a-406d-43cb-885c-ba5233577cad.woff2": 2175,
	"./fonts/08b57253-2e0d-4c12-9c57-107f6c67bc49.woff2": 2176,
	"./fonts/08edde9d-c27b-4731-a27f-d6cd9b01cd06.woff": 2177,
	"./fonts/14d824a2-2a5c-4692-8e30-74f6e177b675.ttf": 2178,
	"./fonts/2025/1635950212302373.otf": 2179,
	"./fonts/2025/SourceHanSansCN-Bold.otf": 2180,
	"./fonts/2025/SourceHanSansCN-Bold.ttf": 2181,
	"./fonts/2025/SourceHanSansCN-ExtraLight.ttf": 2182,
	"./fonts/2025/SourceHanSansCN-Heavy.ttf": 2183,
	"./fonts/2025/SourceHanSansCN-Medium.otf": 2184,
	"./fonts/2025/SourceHanSansCN-Normal.otf": 2185,
	"./fonts/2025/SourceHanSansCN-Regular.otf": 2186,
	"./fonts/2025/SourceHanSansCN-Regular.ttf": 2187,
	"./fonts/22c6282d-e7aa-406b-89dc-5176916a9c44.ttf": 2188,
	"./fonts/240c57a0-fdce-440d-9ce3-85e0cb56f470.woff2": 2189,
	"./fonts/2a34f1f8-d701-4949-b12d-133c1c2636eb.woff": 2190,
	"./fonts/418e7417-47f3-40a1-8817-519a566f9d82.eot": 2191,
	"./fonts/4c21ab66-1566-4a85-b310-fbc649985f88.eot": 2192,
	"./fonts/4cc8f5da-4e24-4929-8efb-866ffcb1fe7e.eot": 2193,
	"./fonts/522972a6-5867-47ae-82fc-a7cf9bd5d4d4.eot": 2194,
	"./fonts/556d95c6-2352-4272-9422-83d53f66cfa3.ttf": 2195,
	"./fonts/5640036d-d549-4f16-b31e-87da78d9e832.eot": 2196,
	"./fonts/7802e576-2ffa-4f22-a409-534355fbea79.woff": 2197,
	"./fonts/7b415a05-784a-4a4c-8c94-67e9288312f5.woff": 2198,
	"./fonts/7d63ccf8-e0ae-4dee-ad4d-bbc798aa5803.woff2": 2199,
	"./fonts/800da3b0-675f-465f-892d-d76cecbdd5b1.woff2": 2200,
	"./fonts/8f4a1705-214a-4dd0-80b8-72252c37e688.ttf": 2201,
	"./fonts/922917a9-4ca8-4c0b-b1bb-417b6ff0210e.ttf": 2202,
	"./fonts/93ce67e5-64e3-4a99-99a3-545f20c5beec.woff2": 2203,
	"./fonts/96b3a113-3e18-46f9-b6e3-5bdee7288b20.woff": 2204,
	"./fonts/b2c1327f-ab3d-4230-93d7-eee8596e1498.woff": 2205,
	"./fonts/cad33bbd-bbf2-423b-98c5-51136c054e14.woff": 2206,
	"./fonts/cb0d1e8a-e111-4dbf-82c2-e948aba954c0.eot": 2207,
	"./fonts/da266c3a-a094-4adc-a81e-12f73609ba16.eot": 2208,
	"./fonts/f07c25ed-2d61-4e44-99ab-a0bc3ec67662.ttf": 2209,
	"./fonts/f9c5199e-a996-4c08-9042-1eb845bb7495.woff2": 2210,
	"./fonts/fdf10d5e-4ce0-45e5-a6c1-5eaff6cb1c11.ttf": 2211,
	"./fsi1.gif": 2212,
	"./fsi2.gif": 2213,
	"./fsi3.gif": 2214,
	"./fsi4.gif": 2215,
	"./fsiRealCase1-en.jpg": 866,
	"./fsiRealCase1-mobile-en.jpg": 867,
	"./fsiRealCase1-mobile-sc.jpg": 868,
	"./fsiRealCase1-mobile.jpg": 869,
	"./fsiRealCase1-sc.jpg": 870,
	"./fsiRealCase1.jpg": 871,
	"./fsiRealCase2-en-mobile.jpg": 872,
	"./fsiRealCase2-en.jpg": 873,
	"./fsiRealCase2-mobile-sc.jpg": 874,
	"./fsiRealCase2-mobile.jpg": 875,
	"./fsiRealCase2-sc.jpg": 876,
	"./fsiRealCase2.jpg": 877,
	"./general2024-1.gif": 2216,
	"./general2024-2.gif": 2217,
	"./general2024-3.gif": 2218,
	"./general2024-4.gif": 2219,
	"./general2024RealCase1-en-mobile.jpg": 878,
	"./general2024RealCase1-en.jpg": 879,
	"./general2024RealCase1-mobile-sc.jpg": 880,
	"./general2024RealCase1-mobile.jpg": 881,
	"./general2024RealCase1-sc.jpg": 882,
	"./general2024RealCase1.jpg": 883,
	"./globe.png": 512,
	"./hacker-using-laptop.gif": 2220,
	"./hacker1-en.png": 2221,
	"./hacker1.png": 2222,
	"./hacker2-en.png": 2223,
	"./hacker2.png": 2224,
	"./hacker3-en.png": 2225,
	"./hacker3.png": 2226,
	"./happy-emoji.png": 135,
	"./homelandingbg.png": 2227,
	"./icon-business.png": 513,
	"./icon-certificate.png": 514,
	"./icon-employee.png": 515,
	"./icon-training.png": 516,
	"./icon-vector1.png": 2228,
	"./icon-vector2.png": 2229,
	"./icon-vector3.png": 2230,
	"./icon-vector4.png": 2231,
	"./icon1.png": 2232,
	"./icon10.png": 2233,
	"./icon11.png": 2234,
	"./icon12.png": 2235,
	"./icon2.png": 2236,
	"./icon3.png": 2237,
	"./icon4.png": 2238,
	"./icon5.png": 2239,
	"./icon6.png": 2240,
	"./icon7.png": 2241,
	"./icon8.png": 2242,
	"./icon9.png": 2243,
	"./info-forgot-password-in.gif": 2244,
	"./info-journey-en.gif": 2245,
	"./info-journey.gif": 2246,
	"./info-new-mail.gif": 2247,
	"./info-password-security.gif": 2248,
	"./info-wifi.gif": 2249,
	"./it-gif1.gif": 2250,
	"./it-gif2.gif": 2251,
	"./it-gif3.gif": 2252,
	"./it-gif4.gif": 2253,
	"./it900-a031-en.jpg": 884,
	"./it900-a031.jpg": 885,
	"./it900-a32-1.jpg": 886,
	"./it900-a32-2.jpg": 887,
	"./it900-a32-3.jpg": 888,
	"./it930-a033-1.jpg": 889,
	"./it930-a033-2.jpg": 890,
	"./it930-a033-3.jpg": 891,
	"./it930-a033-4.jpg": 892,
	"./it930-a033-5-en.jpg": 893,
	"./it930-a033-5.jpg": 894,
	"./lady-right-01.png": 2254,
	"./lady-right.jpg": 895,
	"./lady-right.png": 2255,
	"./landingbg.png": 2256,
	"./logo.png": 2257,
	"./logo/consumer.png": 2258,
	"./logo/cpttm.png": 2259,
	"./logo/hkgcsmeaa.png": 2260,
	"./logo/logo.png": 2261,
	"./man-left-2.svg": 2262,
	"./man-right-2.png": 2263,
	"./man-right.jpg": 896,
	"./man-right2.png": 2264,
	"./man.jpg": 897,
	"./market-gif1.gif": 2265,
	"./market-gif2.gif": 2266,
	"./market-gif3.gif": 2267,
	"./market-gif4.gif": 2268,
	"./market-notpass.png": 517,
	"./market-quiz-info.png": 518,
	"./meeting.png": 2269,
	"./news-en.png": 2270,
	"./news-mobile-en.jpg": 898,
	"./news-mobile-sc.jpg": 899,
	"./news-mobile.jpg": 900,
	"./news-sc.jpg": 901,
	"./news.jpg": 902,
	"./news.png": 2271,
	"./next-icon.svg": 519,
	"./ngo-a035-1.jpg": 903,
	"./ngo-a035-2.jpg": 904,
	"./ngo-a035-3.jpg": 905,
	"./ngo-a035-4.jpg": 906,
	"./ngo-a036-example-en.png": 2272,
	"./ngo-a036-example.jpg": 907,
	"./ngo-gif1.gif": 2273,
	"./ngo-gif2.gif": 2274,
	"./ngo-gif3.gif": 2275,
	"./ngo-gif4.gif": 2276,
	"./notpass.png": 2277,
	"./office-risk1.png": 2278,
	"./office-risk2.png": 2279,
	"./office-risk3.png": 2280,
	"./office-risk4.png": 2281,
	"./office-risk5.png": 2282,
	"./org-brand1.png": 2283,
	"./ornament.png": 236,
	"./p-completed.svg": 2284,
	"./p-notstart.svg": 2285,
	"./p-onprogress-B.jpg": 908,
	"./p-onprogress-E-commerce.png": 2286,
	"./p-onprogress-b.png": 2287,
	"./p-onprogress-cs.png": 2288,
	"./p-onprogress-fsi.png": 2289,
	"./p-onprogress-g.png": 2290,
	"./p-onprogress-general2024.png": 2291,
	"./p-onprogress-it.png": 2292,
	"./p-onprogress-ngo.png": 2293,
	"./p-onprogress-startup.png": 2294,
	"./p-onprogress-student.png": 2295,
	"./p-onprogress.svg": 2296,
	"./p9801.png": 237,
	"./pass.png": 520,
	"./phishing-indentify1.png": 2297,
	"./phishing-indentify2.png": 2298,
	"./phishing-indentify3.png": 2299,
	"./phishing-indentify4-en.png": 2300,
	"./phishing-indentify4.png": 2301,
	"./phishing-indentify5.png": 2302,
	"./phishing-indentify6.png": 2303,
	"./phishing1.png": 2304,
	"./phishing2.png": 2305,
	"./phishing3.png": 2306,
	"./phishing4.png": 2307,
	"./phishingicon1.png": 2308,
	"./phishingicon2.png": 2309,
	"./phishingicon3.png": 2310,
	"./phishingicon4.png": 2311,
	"./plus.png": 114,
	"./popover-red.png": 2312,
	"./popover.png": 2313,
	"./popup1.png": 2314,
	"./prev-icon.svg": 2315,
	"./pwc-logo-dark.png": 2316,
	"./pwc-logo-dark.svg": 2317,
	"./pwc-logo-white.png": 2318,
	"./pwc-logo-white.svg": 2319,
	"./pwc-logo.png": 2320,
	"./pwc-logo.svg": 2321,
	"./quiz-icon.png": 195,
	"./quiz-info.png": 2322,
	"./quizbg.png": 2323,
	"./ransomewareRealcase-en.png": 2324,
	"./ransomewareRealcase-mobile-en.png": 2325,
	"./ransomewareRealcase-mobile.png": 2326,
	"./ransomewareRealcase.png": 2327,
	"./ransomware.png": 2328,
	"./results1.png": 2329,
	"./results2.png": 2330,
	"./results3.png": 2331,
	"./results4.png": 2332,
	"./s3-001.png": 2333,
	"./s3-002.png": 2334,
	"./s3-003.png": 2335,
	"./s3-004.jpg": 909,
	"./s3-005.jpg": 910,
	"./s3-006.jpg": 911,
	"./s3-007.jpg": 912,
	"./s3-008.jpg": 913,
	"./sample.png": 2336,
	"./secure-warning-bg.png": 2337,
	"./secure-warning1.png": 2338,
	"./secure-warning2.png": 2339,
	"./senior-sample1.png": 2340,
	"./senior-sample10.png": 2341,
	"./senior-sample2.png": 2342,
	"./senior-sample3-sc.png": 2343,
	"./senior-sample3.png": 2344,
	"./senior-sample4.png": 2345,
	"./senior-sample5.png": 2346,
	"./senior-sample6.png": 2347,
	"./senior-sample7.png": 2348,
	"./senior-sample8.png": 2349,
	"./senior-sample9.png": 2350,
	"./service.png": 521,
	"./small-icon1.png": 2351,
	"./small-icon10.png": 2352,
	"./small-icon2.png": 2353,
	"./small-icon3.png": 2354,
	"./small-icon4.png": 2355,
	"./small-icon5.png": 2356,
	"./small-icon6.png": 2357,
	"./small-icon7.png": 2358,
	"./small-icon8.png": 2359,
	"./small-icon9.png": 2360,
	"./social-media-bg-g.png": 2361,
	"./social-media-bg.png": 2362,
	"./social-media.gif": 75,
	"./socialMedia.png": 2363,
	"./sponsor-logo/1.png": 914,
	"./sponsor-logo/10.png": 915,
	"./sponsor-logo/11.png": 916,
	"./sponsor-logo/12.png": 917,
	"./sponsor-logo/13.png": 918,
	"./sponsor-logo/14.png": 919,
	"./sponsor-logo/15.png": 920,
	"./sponsor-logo/16.png": 921,
	"./sponsor-logo/17.png": 922,
	"./sponsor-logo/18.png": 923,
	"./sponsor-logo/19.png": 924,
	"./sponsor-logo/2.png": 925,
	"./sponsor-logo/20.png": 926,
	"./sponsor-logo/21.png": 927,
	"./sponsor-logo/22.png": 928,
	"./sponsor-logo/23.png": 929,
	"./sponsor-logo/24.png": 930,
	"./sponsor-logo/25.png": 931,
	"./sponsor-logo/26.png": 932,
	"./sponsor-logo/27.png": 933,
	"./sponsor-logo/28.png": 934,
	"./sponsor-logo/29.png": 935,
	"./sponsor-logo/3.png": 936,
	"./sponsor-logo/30.png": 937,
	"./sponsor-logo/4.png": 938,
	"./sponsor-logo/5.png": 939,
	"./sponsor-logo/6.png": 940,
	"./sponsor-logo/7.png": 941,
	"./sponsor-logo/8.png": 942,
	"./sponsor-logo/9.png": 943,
	"./sponsor-logo/more1.png": 944,
	"./startup1.gif": 2364,
	"./startup2.gif": 2365,
	"./startup3.gif": 2366,
	"./startup4.gif": 2367,
	"./startupRealCase1-en.jpg": 945,
	"./startupRealCase1-mobile-en.jpg": 946,
	"./startupRealCase1-mobile.jpg": 947,
	"./startupRealCase1.jpg": 948,
	"./startupRealCase2-en.jpg": 949,
	"./startupRealCase2-mobile-en.jpg": 950,
	"./startupRealCase2-mobile.jpg": 951,
	"./startupRealCase2.jpg": 952,
	"./step-c-1.png": 55,
	"./step-c-2.png": 56,
	"./step-c-3.png": 57,
	"./step-i-1.png": 2368,
	"./step-i-2.png": 2369,
	"./step-i-3.png": 2370,
	"./step-i-4.png": 2371,
	"./student.svg": 2372,
	"./student1.gif": 2373,
	"./student2.gif": 2374,
	"./student3.gif": 2375,
	"./student4.gif": 2376,
	"./studentRealCase1-en.png": 2377,
	"./studentRealCase1-mobile-en.png": 2378,
	"./studentRealCase1-mobile-sc.jpg": 953,
	"./studentRealCase1-mobile.png": 2379,
	"./studentRealCase1-sc.jpg": 954,
	"./studentRealCase1.png": 2380,
	"./studentRealCase2-en.png": 2381,
	"./studentRealCase2-mobile-en.png": 2382,
	"./studentRealCase2-mobile-sc.jpg": 955,
	"./studentRealCase2-mobile.png": 2383,
	"./studentRealCase2-sc.jpg": 956,
	"./studentRealCase2.png": 2384,
	"./support-org1.png": 2385,
	"./support-org2.png": 2386,
	"./support-org3.png": 2387,
	"./support-org4.png": 2388,
	"./test046.png": 2389,
	"./tip-arrow.png": 2390,
	"./tip1.png": 2391,
	"./tip2.png": 2392,
	"./tip3.png": 2393,
	"./tip4.png": 2394,
	"./tip5.png": 2395,
	"./tipbg.png": 2396,
	"./tips-person.png": 157,
	"./tips-person.svg": 2397,
	"./topic1.png": 2398,
	"./topic1200.png": 2399,
	"./topic1200bg.png": 2400,
	"./topic1400.png": 2401,
	"./topic1400bg.png": 2402,
	"./topic2.png": 2403,
	"./topic3.png": 2404,
	"./topic4.png": 2405,
	"./topic6.png": 2406,
	"./topic7.png": 2407,
	"./topic900.png": 2408,
	"./topic900bg.png": 2409,
	"./topic930.png": 2410,
	"./topic930bg.png": 2411,
	"./training-illustration.png": 2412,
	"./training-illustration10.png": 2413,
	"./training-illustration11.png": 2414,
	"./training-illustration12.png": 2415,
	"./training-illustration13.png": 2416,
	"./training-illustration2.png": 2417,
	"./training-illustration20.png": 2418,
	"./training-illustration25.png": 2419,
	"./training-illustration26.png": 2420,
	"./training-illustration3.png": 2421,
	"./training-illustration4.svg": 2422,
	"./training-illustration5.svg": 2423,
	"./training-illustration6.svg": 2424,
	"./training-illustration7.png": 2425,
	"./training-illustration8.png": 2426,
	"./training-illustration9.png": 2427,
	"./transcrip.png": 196,
	"./unhappy-emoji.png": 136,
	"./useful-link-Icon.png": 2428,
	"./vector.png": 2429,
	"./vector137.png": 2430,
	"./video1-en.mp4": 2431,
	"./video1.mp4": 2432,
	"./video1more.mp4": 2433,
	"./video2.mp4": 2434,
	"./warning-alert-bg.png": 2435,
	"./warning-alert-bg2.png": 2436,
	"./welc1.gif": 2437,
	"./welc2.gif": 2438,
	"./welc3.gif": 2439,
	"./welc4.gif": 2440,
	"./welcome.gif": 2441,
	"./welcomeInfo.png": 2442,
	"./welcomeInfo2.png": 2443,
	"./welcomeInfo3.png": 2444,
	"./welcomeLandingbg-E-commerce.png": 2445,
	"./welcomeLandingbg-fsi.png": 2446,
	"./welcomeLandingbg-general2024.png": 2447,
	"./welcomeLandingbg-it.png": 2448,
	"./welcomeLandingbg-ngo.png": 2449,
	"./welcomeLandingbg-startup.png": 2450,
	"./welcomeLandingbg-student.png": 2451,
	"./welcomeLandingbg.png": 2452,
	"./whatsApp.png": 2453,
	"./whatsAppRealcase-en-mobile.png": 2454,
	"./whatsAppRealcase-en.png": 2455,
	"./whatsAppRealcase-mobile.png": 2456,
	"./whatsAppRealcase.png": 2457,
	"./working.png": 2458
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;